import { getPlatform } from '@thriveglobal/thrive-web-core'
import { useMemo } from 'react'

const IOS_PLATFORM = 'hybrid-ios'

export const useIsIos = (): boolean => {
    return useMemo(() => getPlatform() === IOS_PLATFORM, [])
}
